import client from '@services/TokenInterceptorServices';

export const getOpportunitiesDue = async (ROLE, EMAIL, systemDateTime) => {
  const URL = '/user/date';
  if (ROLE === 'MSL READ ONLY' || ROLE === 'MSL DELEGATE') {
    ROLE = 'MSL';
  } else if (ROLE === 'GCSP READ ONLY') {
    ROLE = 'GCSP';
  }
  const PAYLOAD = { role: ROLE, email: EMAIL, date: systemDateTime };

  const RESPONSE = await client.post(URL, PAYLOAD);
  return RESPONSE.data;
};

export const getForecastSubmittedStatus = async apiPayload => {
  const { email, role, month, year, accountId } = apiPayload;
  let URL;
  let PAYLOAD;

  if (role === 'MSL' || role === 'MSL DELEGATE') {
    URL = '/msl/forecastsubmitstatus';
    PAYLOAD = { email, role: 'MSL', month, year, performing_segment: accountId };
  } else if (role === 'GCSP') {
    URL = '/gcsp/forecastsubmitstatus';
    PAYLOAD = { email, role, month, year, account_id: accountId };
  } else if (role === 'PL') {
    URL = '/pl/forecastsubmitstatus';
    PAYLOAD = { email, role, month, year };
  }

  const RESPONSE = await client.post(URL, PAYLOAD);
  return role === 'GCSP' || role === 'MSL' || role === 'MSL DELEGATE'
    ? RESPONSE.data[accountId]
    : RESPONSE.data;
};

export const getPlResubmissionStatus = async apiPayload => {
  const { email, month, year } = apiPayload;
  const URL = 'pl/resubmitstatus';
  const PAYLOAD = { email, month, year };

  const RESPONSE = await client.post(URL, PAYLOAD);
  return RESPONSE.data;
};

export const getUserRole = async (EMAIL, COUNTRY_NAME) => {
  const URL = 'user/identifypersona';
  const PAYLOAD = { email: EMAIL, country: COUNTRY_NAME };

  const RESPONSE = await client.post(URL, PAYLOAD);
  return RESPONSE.data;
};

export const getAllRoleQuarterlyData = async (EMAIL, systemDateTime) => {
  // Email Required *
  const URL = '/user/personaquaterlyinfo';
  const PAYLOAD = { email: EMAIL, date: systemDateTime };
  const RESPONSE = await client.post(URL, PAYLOAD);
  return RESPONSE.data;
};

export const getDashboardProfileDetails = async EMAIL => {
  const URL = 'user/dashboard/profiledetails';
  const PAYLOAD = { email: EMAIL };

  const RESPONSE = await client.post(URL, PAYLOAD);
  return RESPONSE.data;
};

// Abonded API: Interested person can adopt this API
export const getSystemDateTime = async EMAIL => {
  const URL = 'user/systemtime';
  const PAYLOAD = { email: EMAIL };

  const RESPONSE = await client.post(URL, PAYLOAD);
  return RESPONSE.data;
};

export const getLogOutStatus = async EMAIL => {
  const URL = '/user/logout';
  const PAYLOAD = { email: EMAIL };

  const RESPONSE = await client.post(URL, PAYLOAD);
  return RESPONSE.data;
};

export const getDashboardAllQuartersData = async (EMAIL, YEAR, TODAYS_DATE, ROLE, ACCOUNT_ID) => {
  const URL = '/user/dashboard/all/quarterlymetrics';
  const PAYLOAD = {
    email: EMAIL,
    year: YEAR,
    date: TODAYS_DATE,
    role: ROLE,
  };

  if (ROLE === 'MSL') {
    PAYLOAD.marketSegmentId = ACCOUNT_ID;
  } else {
    PAYLOAD.account_id = ACCOUNT_ID;
  }

  const RESPONSE = await client.post(URL, PAYLOAD);
  return RESPONSE.data;
};

export const getDashboardSingleQuartersData = async (
  ROLE,
  EMAIL,
  YEAR,
  QUARTER,
  TODAYS_DATE,
  ACCOUNT_ID,
  SERVICE,
) => {
  const USER_ROLE = ROLE?.toLowerCase();
  const URL = `/${USER_ROLE}/dashboard/quaterlymetrics`;
  const PAYLOAD = {
    email: EMAIL,
    year: YEAR,
    quarter: QUARTER,
    date: TODAYS_DATE,
  };

  if (ROLE === 'PL') {
    PAYLOAD.service = SERVICE?.toLowerCase();
  } else if (ROLE === 'MSL') {
    PAYLOAD.marketSegmentId = ACCOUNT_ID;
    PAYLOAD.service = SERVICE === 'emia_acr' ? 'emeia_acr' : SERVICE?.toLowerCase();
  } else {
    PAYLOAD.account_id = ACCOUNT_ID;
    PAYLOAD.service = SERVICE?.toLowerCase();
  }

  const RESPONSE = await client.post(URL, PAYLOAD);
  return RESPONSE.data;
};

export const userOnboardingSubmit = async REQ_BODY => {
  const URL = '/user/useronboarding';
  const RESPONSE = await client.post(URL, REQ_BODY);
  return {
    status: RESPONSE.status,
    msg: RESPONSE.data.status,
    data: RESPONSE.data,
  };
};

export const checkForSuperUser = async EMAIL => {
  const REQ_BODY = {
    email: EMAIL,
  };
  const URL = '/user/checksuperuser';
  const response = await client.post(URL, REQ_BODY);
  return response.data;
};
